
export enum ClaimAdditionalPaymentReasonCd {
	CUSTOMER_ADDED_ADDITIONAL_ITEMS_OR_FREIGHT = 'CustomerAddedAdditionalItemsOrFreight',
	CUSTOMER_PROVIDED_MISSING_INFORMATION = 'CustomerProvidedMissingInformation',
	INCORRECT_LIABILITY_LIMIT_USED = 'IncorrectLiabilityLimitUsed',
	LEGAL_DECISION = 'LegalDecision',
	OTHER = 'Other',
	SHOULD_HAVE_PAID_FREIGHT_CHARGES = 'ShouldHavePaidFreightCharges'}

